import { c as _c } from "react/compiler-runtime";
import type { ts } from '@funkey/shared';
export function curryProps<P extends Record<string, unknown>, T extends Partial<P>>(Component: React.FC<P>, props: T): React.FC<Omit<P, keyof ts.Object.Keys.filter<T, undefined>>> {
  // eslint-disable-next-line react/display-name
  return restingProps => <Component {...props as unknown as P} {...restingProps as unknown as P} />;
}

/** A utility function to easilly wrap components with a wrapper like `<Suspense />` */
export function wrapComponent<P, WP>(Component: React.FC<P>, Wrapper: React.FC<React.PropsWithChildren<WP>>): React.FC<P & {
  wrapper?: WP;
}> {
  const ComponentWrapped: React.FC<P & {
    wrapper?: WP;
  }> = t0 => {
    const $ = _c(8);
    let props;
    let wrapper;
    if ($[0] !== t0) {
      ({
        wrapper,
        ...props
      } = t0);
      $[0] = t0;
      $[1] = props;
      $[2] = wrapper;
    } else {
      props = $[1];
      wrapper = $[2];
    }
    const t1 = wrapper as any;
    const t2 = props as any;
    let t3;
    if ($[3] !== t2) {
      t3 = <Component {...t2} />;
      $[3] = t2;
      $[4] = t3;
    } else {
      t3 = $[4];
    }
    let t4;
    if ($[5] !== t1 || $[6] !== t3) {
      t4 = <Wrapper {...t1}>{t3}</Wrapper>;
      $[5] = t1;
      $[6] = t3;
      $[7] = t4;
    } else {
      t4 = $[7];
    }
    return t4;
  };
  ComponentWrapped.displayName = `${Component.displayName}_wrappedWith_${Wrapper.displayName}`;
  return ComponentWrapped;
}